import { configureStore } from '@reduxjs/toolkit';
import combineReducers from './combine-reducers';
import { adminsApi } from 'services/adminsApi';
import { transactionsDistinctRecipientsApi } from 'services/transactionsDistinctRecipientsApi';
import { donationExportApi } from 'services/donationExportApi';
import { getPayoutReportSignedUrlApi } from 'services/payoutDownloadApi';
import { baseApi } from 'services/baseApi';
import { nextPayoutAmountApi } from 'services/nextPayoutAmountApi';
import { adminRecipientsApi } from 'services/adminRecipientsApi';
import { adminCandidatesApi } from 'services/adminCandidatesApi';
import { recipientAdminsApi } from 'services/recipientAdminsApi';
import { setsApi } from 'services/setsApi';
import { eventPagesForReportApi } from 'services/eventPagesForReportApi';
import { eventTicketDownloadApi } from 'services/eventTicketDownloadApi';
import { impactScoreEligibilityApi } from 'services/impactScoreEligibilityApi';
import { recipientRaceApi } from 'services/recipientRaceApi';
import { shoppingCartApi } from 'services/shoppingCartApi';
import { clientFiltersApi } from 'services/clientFiltersApi';

const DEV_DEFAULT_TRACE_LIMIT = 10;

const store = configureStore({
  reducer: combineReducers,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(
      adminsApi.middleware,
      transactionsDistinctRecipientsApi.middleware,
      donationExportApi.middleware,
      getPayoutReportSignedUrlApi.middleware,
      baseApi.middleware,
      nextPayoutAmountApi.middleware,
      adminRecipientsApi.middleware,
      adminCandidatesApi.middleware,
      recipientAdminsApi.middleware,
      setsApi.middleware,
      eventPagesForReportApi.middleware,
      eventTicketDownloadApi.middleware,
      impactScoreEligibilityApi.middleware,
      recipientRaceApi.middleware,
      shoppingCartApi.middleware,
      clientFiltersApi.middleware
    ),

  devTools:
    process.env.NODE_ENV === 'development'
      ? {
          trace:
            (Boolean(process.env.REACT_APP_DEV_TRACE) && process.env.REACT_APP_ENV === 'local') ||
            false,
          traceLimit: Number(process.env.REACT_APP_DEV_TRACE_LIMIT) || DEV_DEFAULT_TRACE_LIMIT,
        }
      : true,
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
